import { get, post, patch } from 'services/http';

const fetchWidgetById = id => get(`/widgets/${id}`, { addKgId: true, addSessionId: true });

const fetchWidgetsByBoardId = id => get(`/boards/${id}/widgets`, { addKgId: true });

const cancelWidget = id => post(`/widgets/${id}/cancel`, null, { addKgId: true, addSessionId: true });

const addWidgetToBoard = (boardId, widget) => post(`/boards/${boardId}/widgets`, widget, { addKgId: true });

const updateWidgetsOfBoard = (boardId, widgets) =>
  patch(`/boards/${boardId}/widgets`, widgets, null, { addKgId: true });

export default { cancelWidget, fetchWidgetById, fetchWidgetsByBoardId, addWidgetToBoard, updateWidgetsOfBoard };
